/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum AccountCreationStepsAliases {
  AUTOCOMPLETE_DEPARTMENTS = 'autocomplete-departments',
  AUTOCOMPLETE_DOCUMENT_TYPE = 'autocomplete-document-type',
  AUTOCOMPLETE_GENDER = 'autocomplete-gender',
  AUTOCOMPLETE_NATIONAL = 'autocomplete-national',
  AUTOCOMPLETE_VIEW_DEPARTMENTS = 'autocomplete-view-departments',
  AUTOCOMPLETE_VIEW_NATIONAL = 'autocomplete-view-national',
  CHECKBOX_AGREE_TERMS = 'checkbox-agree-terms',
  CHECKLIST_USE_FOREING_IDS = 'checklist-use-foreing-ids',
  FETCH_0 = 'fetch-0',
  FETCH_DEPARTMENTS = 'fetch-departments',
  FETCH_DOCUMENT_TYPE = 'fetch-document-type',
  FETCH_GENDER = 'fetch-gender',
  FETCH_NATIONAL = 'fetch-national',
  FETCH_VIEW_DEPARTMENTS = 'fetch-view-departments',
  FETCH_VIEW_NATIONAL = 'fetch-view-national',
  FIELD_AGREE_TERMS = 'field-agree-terms',
  FIELD_BINARY_GENDER = 'field-binary-gender',
  FIELD_BRASIL_CPF = 'field-brasil-cpf',
  FIELD_BRASIL_IDENTIDADE = 'field-brasil-identidade',
  FIELD_CONFIRM_EMAIL = 'field-confirm-email',
  FIELD_CONFIRM_PASSWORD = 'field-confirm-password',
  FIELD_DEPARTMENTS = 'field-departments',
  FIELD_DOB = 'field-dob',
  FIELD_DOCUMENT_TYPE = 'field-document-type',
  FIELD_DOCUMENT_VALUE = 'field-document-value',
  FIELD_EMAIL = 'field-email',
  FIELD_FOREIGN_ID = 'field-foreign-id',
  FIELD_FOREIGN_NATIONALITY = 'field-foreign-nationality',
  FIELD_FOREIGN_PASSPORT = 'field-foreign-passport',
  FIELD_FULLNAME = 'field-fullname',
  FIELD_GENDER = 'field-gender',
  FIELD_MAIN_PERSON_NAME_1 = 'field-main-person-name-1',
  FIELD_MAIN_PERSON_NAME_2 = 'field-main-person-name-2',
  FIELD_MAIN_PERSON_NAME_3 = 'field-main-person-name-3',
  FIELD_MAIN_PERSON_NAME_4 = 'field-main-person-name-4',
  FIELD_MAIN_PERSON_NAME_5 = 'field-main-person-name-5',
  FIELD_MEDICARE = 'field-medicare',
  FIELD_PASSWORD = 'field-password',
  FIELD_PHONE = 'field-phone',
  FIELD_SMS_EMAIL = 'field-sms-email',
  FIELD_UPLOADER_DOCUMENTS = 'field-uploader-documents',
  FIELD_USE_FOREING_IDS = 'field-use-foreing-ids',
  FIELD_USER_INACTIVE = 'field-user-inactive',
  FIELD_USERNAME = 'field-username',
  FIELD_VERIFYING_DIGIT = 'field-verifying-digit',
  FIELD_VIEW_BRASIL_CPF = 'field-view-brasil-cpf',
  FIELD_VIEW_BRASIL_IDENTIDADE = 'field-view-brasil-identidade',
  FIELD_VIEW_DEPARTMENTS = 'field-view-departments',
  FIELD_VIEW_DOB = 'field-view-dob',
  FIELD_VIEW_FOREIGN_ID = 'field-view-foreign-id',
  FIELD_VIEW_FOREIGN_NATIONALITY = 'field-view-foreign-nationality',
  FIELD_VIEW_FOREIGN_PASSPORT = 'field-view-foreign-passport',
  FIELD_VIEW_FULLNAME = 'field-view-fullname',
  FIELD_VIEW_GENDER = 'field-view-gender',
  FIELD_VIEW_MAIN_PERSON_NAME_1 = 'field-view-main-person-name-1',
  FIELD_VIEW_MAIN_PERSON_NAME_2 = 'field-view-main-person-name-2',
  FIELD_VIEW_MAIN_PERSON_NAME_3 = 'field-view-main-person-name-3',
  FIELD_VIEW_MAIN_PERSON_NAME_4 = 'field-view-main-person-name-4',
  FIELD_VIEW_MAIN_PERSON_NAME_5 = 'field-view-main-person-name-5',
  FIELD_VIEW_MEDICARE = 'field-view-medicare',
  FIELD_VIEW_PHONE = 'field-view-phone',
  FIELD_VIEW_VERIFYING_DIGIT = 'field-view-verifying-digit',
  FIELDSET_ACCOUNT_DATA = 'fieldset-account-data',
  FILE_UPLOADER_DOCUMENTS = 'file-uploader-documents',
  FORM_ACCOUNT_INFORMATION = 'form-account-information',
  FORM_PERSONAL_IDENTIFICATION = 'form-personal-identification',
  FORM_PERSONAL_INFORMATION = 'form-personal-information',
  FORM_UPLOADER_DOCUMENTS = 'form-uploader-documents',
  FORM_VIEW_PERSONAL_IDENTIFICATION = 'form-view-personal-identification',
  FORM_VIEW_PERSONAL_INFORMATION = 'form-view-personal-information',
  INPUT_BRASIL_CPF = 'input-brasil-cpf',
  INPUT_BRASIL_IDENTIDADE = 'input-brasil-identidade',
  INPUT_CONFIRM_EMAIL = 'input-confirm-email',
  INPUT_CONFIRM_PASSWORD = 'input-confirm-password',
  INPUT_DOB = 'input-dob',
  INPUT_DOCUMENT_VALUE = 'input-document-value',
  INPUT_EMAIL = 'input-email',
  INPUT_FOREIGN_ID = 'input-foreign-id',
  INPUT_FOREIGN_PASSPORT = 'input-foreign-passport',
  INPUT_FULLNAME = 'input-fullname',
  INPUT_MAIN_PERSON_NAME_1 = 'input-main-person-name-1',
  INPUT_MAIN_PERSON_NAME_2 = 'input-main-person-name-2',
  INPUT_MAIN_PERSON_NAME_3 = 'input-main-person-name-3',
  INPUT_MAIN_PERSON_NAME_4 = 'input-main-person-name-4',
  INPUT_MAIN_PERSON_NAME_5 = 'input-main-person-name-5',
  INPUT_MEDICARE = 'input-medicare',
  INPUT_PASSWORD = 'input-password',
  INPUT_PHONE = 'input-phone',
  INPUT_USERNAME = 'input-username',
  INPUT_VERIFYING_DIGIT = 'input-verifying-digit',
  INPUT_VIEW_BRASIL_CPF = 'input-view-brasil-cpf',
  INPUT_VIEW_BRASIL_IDENTIDADE = 'input-view-brasil-identidade',
  INPUT_VIEW_DOB = 'input-view-dob',
  INPUT_VIEW_FOREIGN_ID = 'input-view-foreign-id',
  INPUT_VIEW_FOREIGN_PASSPORT = 'input-view-foreign-passport',
  INPUT_VIEW_FULLNAME = 'input-view-fullname',
  INPUT_VIEW_GENDER = 'input-view-gender',
  INPUT_VIEW_MAIN_PERSON_NAME_1 = 'input-view-main-person-name-1',
  INPUT_VIEW_MAIN_PERSON_NAME_2 = 'input-view-main-person-name-2',
  INPUT_VIEW_MAIN_PERSON_NAME_3 = 'input-view-main-person-name-3',
  INPUT_VIEW_MAIN_PERSON_NAME_4 = 'input-view-main-person-name-4',
  INPUT_VIEW_MAIN_PERSON_NAME_5 = 'input-view-main-person-name-5',
  INPUT_VIEW_MEDICARE = 'input-view-medicare',
  INPUT_VIEW_PHONE = 'input-view-phone',
  INPUT_VIEW_VERIFYING_DIGIT = 'input-view-verifying-digit',
  LAYOUT_ROOT = 'layout-root',
  LINK_USER_INACTIVE = 'link-user-inactive',
  MAPPER_DEPARTMENTS = 'mapper-departments',
  MAPPER_DOCUMENT_TYPE = 'mapper-document-type',
  MAPPER_GENDER = 'mapper-gender',
  MAPPER_NATIONAL = 'mapper-national',
  MAPPER_VIEW_DEPARTMENTS = 'mapper-view-departments',
  MAPPER_VIEW_NATIONAL = 'mapper-view-national',
  RADIO_GENDER = 'radio-gender',
  RADIO_SMS_EMAIL = 'radio-sms-email',
  RECAPTCHA = 'recaptcha',
  RECAPTCHA_FIELD = 'recaptcha-field',
  TEXT_DEPARTMENTS = 'text-departments',
  TEXT_DOCUMENT_TYPE = 'text-document-type',
  TEXT_GENDER = 'text-gender',
  TEXT_NATIONAL = 'text-national',
  TEXT_VIEW_DEPARTMENTS = 'text-view-departments',
  TEXT_VIEW_NATIONAL = 'text-view-national',
  TOAST_NOTIFICATION_UPLOAD_DOCUMENTS = 'toast-notification-upload-documents',
  WIZARD_ACCOUNT_CREATION = 'wizard-account-creation',
  WIZARD_ACCOUNT_INFORMATION = 'wizard-account-information',
  WIZARD_STEP_PERSONAL_IDENTIFICATION = 'wizard-step-personal-identification',
  WIZARD_STEP_PERSONAL_INFORMATION = 'wizard-step-personal-information',
  WIZARD_STEP_UPLOAD_DOCUMENTS = 'wizard-step-upload-documents',
}
export { AccountCreationStepsAliases };
